module.exports = __webpack_public_path__ + "images/166_1024.jpg";